module.exports = "https://dashboard.cdn.gifty.nl/6217/images/emoti-5.png?ca6f6a3be4cd7e37666c8e3de438c7df";